import styled from '@emotion/styled'
import theme from '@utils/theme'

// Common Styles

export const FormWrapper = styled.div`
  background: white;
  padding: 30px;
  border-radius: 10px;
  border: 1px solid ${theme.colors.borderBlue};

  @media (max-width: 1024px) {
    border: none;
    padding: 0px;
  }
`

// Manage Profile Styles

export const ProfileContainer = styled.div`
  max-width: 800px;
  width: 60%;
  margin: 0 auto;
  margin: 40px auto;
  @media (max-width: 768px) {
    width: 100%;
  }
`
export const ProfileHeader = styled.div`
  margin-bottom: 30px;
  text-align: center;
`
export const AvatarWrapper = styled.div`
  width: 120px;
  height: 120px;
  margin: 0 auto 20px;
  position: relative;
`
export const AvatarImage = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #d9eaff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
  border: 2px solid #e0e0e0;
`
export const UploadButton = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  background: white;
  border-radius: 50%;
  padding: 8px;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
`

export const FormRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
`

// Create Book Styles

// Styled components
const CreateBookContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`

const UploadImagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  gap: 20px;
`

const CoverImageWrapper = styled.div`
  flex: 1;
  min-width: 300px;
`

const ThumbnailsRow = styled.div`
  display: grid;
  place-content: center;
  grid-template-columns: repeat(4, 1fr);

  gap: 16px;
`

const StyleCreateBookForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const StyleFixedButton = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  padding: 8px 12px;
  border-top: 1px solid #e0e0e0;
`

const FieldsRow = styled.div`
  display: flex;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

const SubmitButtonContainer = styled.div`
  margin-top: 24px;

  button {
    width: 100%;
    background-color: #0275d8;
    color: white;
    padding: 12px;
    border-radius: 4px;
    font-weight: 500;
    transition: background-color 0.2s;

    &:hover {
      background-color: #0267c1;
    }
  }
`

export {
  CreateBookContainer,
  UploadImagesContainer,
  ThumbnailsRow,
  SubmitButtonContainer,
  CoverImageWrapper,
  StyleCreateBookForm,
  FieldsRow,
}

// Show All Books Styles

export const StyleBooksPageWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

export const StyleBookCard = styled.div`
  width: 100%;
  padding: 10px;
  display: flex;
  gap: 10px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.borderBlue};
`
export const StyleBookName = styled.p`
  font-size: 24px;
  font-weight: 600;
`
export const StyleBookAuthor = styled.p`
  font-size: 24px;
  color: ${theme.colors.text100};
`
export const StyleBookCategory = styled.p`
  font-size: 16px;
`

// Book Description Styles

export const BookContent = styled.div`
  display: flex;
  gap: 20px;
  padding: 12px 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0px;
  }
`
export const BookImages = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;
  gap: 20px;
  @media (max-width: 768px) {
    width: 100%;
  }
`
export const CoverImage = styled.div`
  width: 250px;
  height: auto;

  @media (max-width: 768px) {
    width: 200px;
  }
`
export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover; // This makes the image cover the entire container while maintaining aspect ratio
  /* Alternative options:
   object-fit: contain; // This will fit the entire image within the container, might leave empty space
   object-fit: fill;    // This will stretch the image to fill the container, might distort the image
*/
  display: block; // Removes any extra space below the image
  border-radius: 4px;
`
export const AdditionalImages = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: nowrap;
  height: 60px;
  overflow-x: hidden;
`
export const BookDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 50%;
  text-align: justify;

  @media (max-width: 768px) {
    width: 100%;
    gap: 8px;
  }
`
export const BookTitle = styled.p`
  font-size: 32px;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`
export const BookCategory = styled.p`
  font-size: 18px;
  color: ${theme.colors.primary};
  background: ${theme.colors.primary50};
  padding: 4px 8px;
  border-radius: 8px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
  @media (max-width: 480px) {
    font-size: 14px;
  }
`
export const AuthorName = styled.p`
  font-size: 18px;
  color: ${theme.colors.orange};
  background-color: ${theme.colors.orangeLight};
  padding: 4px 8px;
  border-radius: 8px;
  @media (max-width: 768px) {
    font-size: 16px;
  }
  @media (max-width: 480px) {
    font-size: 14px;
  }
`
export const BookDescriptionTitle = styled.p`
  font-size: 24px;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`
export const Description = styled.p`
  font-size: 16px;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`
